export default {
    name: 'uat',
    baseURL: 'https://uat-api.vinaid.vn:8080',
    reportURL: 'https://uat-api.vinaid.vn:1450',
    kiotUrl: 'https://uat-api.vinaid.vn:1446',
    wsURL: 'https://uat-api.vinaid.vn:8080/socket',
    s3url: 'https://uat-s3.vinaid.vn',
    captchaSiteKey: '6LebPe0pAAAAAFD3s5kOKTRyelGPpJwh21LAsA2f',
}
